import Env from '../base/env'
import Channels from '../base/channels'
import Component from 'gia/Component';
import gsap from 'gsap'
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.gallery = this.DOM.view.querySelector('.wp-block-gallery')
    this.DOM.cover = this.DOM.view.querySelector('.js-cover')
    this.DOM.coverVisual = this.DOM.cover.querySelector('.js-visual')
    this.DOM.coverText = this.DOM.cover.querySelector('.js-text')
    //! Fns
    setTimeout(() => {
      this.fxGallery()
    }, 1000);

    const getScrollPos = Env.framework.toolbox.scrollPosition()
    if(getScrollPos === 0) {
      console.log('baller');
      Env.$html.classList.add('ui-white')
    }

    //! Launch Intro
    this.prepareIntro()
    this.funcLaunch = this.intro.bind(this)
    this.channels()
  }

  channels()
  {
    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  destroy()
  {
      Channels.removeListener('launcher::exit', this.funcLaunch);
  }


  fxGallery()
  {
    const viewport = Env.framework.toolbox.getViewport()
    const DOM = {}
    DOM.images = this.DOM.gallery.querySelectorAll('figure')
    const coordsLast = DOM.images[DOM.images.length - 1].getBoundingClientRect()
    const limitX = viewport.width - (coordsLast.width + coordsLast.x)

    const offsetStart = (Env.mobileCSS)?'top 60%':'top bottom';
    const offsetBottom = (Env.mobileCSS)?'bottom top':'bottom top';
    gsap.fromTo(
      this.DOM.gallery,
      {
        x:0
      },
      {
        x:limitX,
        ease:'quint.out',
        duration:3,
        scrollTrigger:{
          trigger:this.DOM.gallery,
          start:offsetStart,
          end:offsetBottom,
          scrub:2,
          markers:false
        }
      }
    )
  }

  intro()
  {
    const tl = gsap.timeline()

    tl.add([
      gsap.fromTo(
        this.DOM.coverText,
        {
          y:20
        },
        {
          y:0,
          autoAlpha:1,
          duration:1.2,
          ease:'cubic.out',
          delay:.2
        }
      ),
      gsap.fromTo(
        this.DOM.coverVisual.querySelector('img'),
        {
          autoAlpha:0,
          scale:1.05
        },
        {
          autoAlpha:1,
          scale:1.01,
          ease:'cubic.out',
          duration:1.5
        }
      )
    ])
  }

  prepareIntro()
  {
    gsap.set(this.DOM.coverText, { autoAlpha:0 })
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
  }
}
